<template>
    <div class="input-uniq-checker">
        <div class="input--checker">
            <CustomInput v-bind="$props" :value="value" @input="inputChange" class="stretch" />
            <font-awesome-icon
                v-if="!disabled && isChecking"
                icon="circle-notch"
                spin
                class="fa-lg status blue"
            />
            <font-awesome-icon
                v-if="!disabled && !isChecking && !err"
                icon="check-circle"
                class="fa-lg status green"
            />
            <font-awesome-icon
                v-if="!disabled && !isChecking && err"
                icon="times-circle"
                class="fa-lg status red"
            />
        </div>
        <div v-if="err" class="err-msg">{{ err }}</div>
    </div>
</template>

<script>
import CustomInput from './Input';
import debounce from './../lib/debounce';

export default {
    props: {
        ...CustomInput.props,
        url: {
            type: String,
            required: true,
        },
        errMsg: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isChecking: false,
            err: null,
        };
    },
    mounted() {
        this.debouncedCheck = debounce(this._checkValue, 500);
    },
    methods: {
        inputChange(event) {
            this.$emit('input', event);
            this.debouncedCheck(event);
        },
        _checkValue(value) {
            if (!value) {
                return;
            }
            this.isChecking = true;
            this.$http
                .get(`${this.url}/${value}`)
                .then((response) => {
                    const statut = response.body.statut;
                    this.err = !statut && this.errMsg;
                })
                .catch((error) => {
                    this.err = `Une erreur est survenue : ${JSON.stringify(error)}`;
                })
                .finally(() => (this.isChecking = false));
        },
    },
    components: {
        CustomInput,
    },
};
</script>

<style lang="scss">
.input-uniq-checker {
    position: relative;
    // display: flex;
    // align-items: center;

    .input--checker {
        position: relative;

        // &.stretch {
        // display: flex;
        // flex: 1;
        // }

        .status {
            position: absolute;
            bottom: 9px;
            right: 10px;

            &.green {
                color: #93c11f;
            }

            &.red {
                color: #ea5b0c;
            }
        }
    }

    .err-msg {
        position: absolute;
        right: 0;
        bottom: 100%;
        margin-bottom: 9px;
        color: #ea5b0c;
        font-weight: 700;
    }
}
</style>
